import { createAction } from "@reduxjs/toolkit";
import { IApiSelectOption } from "../../components/application/advancedsearch/AdvancedSearchElement";
import { createRsaaAction } from "../../components/utilities/ReduxUtils";
import type {
    CreateAccountRequest,
    CreateAccountResponse,
    GetOrganizationsResponse,
    LicenseResponse,
    OrganizationLicenseResponse,
    OrganizationLicensesResponse,
    OrganizationResponse,
    OrganizationUsersResponse,
    OrganizationsBillingCustomersResponse,
    OrganizationsFeaturesResponse,
    SetUserPasswordRequest,
    UpdateOrganizationFeaturesRequest,
    UpdateOrganizationLicenseRequest,
    UpdateOrganizationRequest,
} from "../../data/models/schemas";

export const ADMIN_GET_FEATURES = "ADMIN_GET_FEATURES";
export const ADMIN_GET_LICENSES = "ADMIN_GET_LICENSES";
export const ADMIN_GET_ORGANIZATIONS = "ADMIN_GET_ORGANIZATIONS";
export const ADMIN_GET_ORGANIZATION = "ADMIN_GET_ORGANIZATION";
export const ADMIN_UPDATE_ORGANIZATION = "ADMIN_UPDATE_ORGANIZATION";
export const ADMIN_GET_ORGANIZATION_LICENSES =
    "ADMIN_GET_ORGANIZATION_LICENSES";
export const ADMIN_SAVE_ORGANIZATION_LICENSE =
    "ADMIN_SAVE_ORGANIZATION_LICENSE";
export const ADMIN_GET_ORGANIZATION_USERS = "ADMIN_GET_ORGANIZATION_USERS";
export const ADMIN_SET_ORGANIZATION_USER_PASSWORD =
    "ADMIN_SET_ORGANIZATION_USER_PASSWORD";
export const ADMIN_UPDATE_ORGANIZATION_FEATURES =
    "ADMIN_UPDATE_ORGANIZATION_FEATURES";
export const ADMIN_GET_ORGANIZATION_FEATURES =
    "ADMIN_GET_ORGANIZATION_FEATURES";
export const ADMIN_GET_ORGANIZATION_BILLING_CUSTOMERS =
    "ADMIN_GET_ORGANIZATION_BILLING_CUSTOMERS";
export const ADMIN_CREATE_ACCOUNT = "ADMIN_CREATE_ACCOUNT";
export const ADMIN_CLOSE_CREATE_ACCOUNT_RESULT =
    "ADMIN_CLOSE_CREATE_ACCOUNT_RESULT";

export type IGetOrganizationsResponse = GetOrganizationsResponse;

export const getFeatures = createRsaaAction<void, IApiSelectOption[]>({
    path: "admin/features",
    method: "GET",
    type: ADMIN_GET_FEATURES,
});

export const getLicenses = createRsaaAction<void, LicenseResponse[]>({
    path: "admin/licenses",
    method: "GET",
    type: ADMIN_GET_LICENSES,
});

export const getOrganizations = createRsaaAction<
    void,
    IGetOrganizationsResponse
>({
    path: "admin/organizations",
    method: "GET",
    type: ADMIN_GET_ORGANIZATIONS,
});

export const getOrganization = createRsaaAction<void, OrganizationResponse>({
    path: "admin/organizations/:organizationId",
    method: "GET",
    type: ADMIN_GET_ORGANIZATION,
});

export const updateOrganization = createRsaaAction<
    UpdateOrganizationRequest,
    OrganizationResponse
>({
    path: "admin/organizations/:organizationId",
    method: "PATCH",
    type: ADMIN_UPDATE_ORGANIZATION,
});

export const getOrganizationLicenses = createRsaaAction<
    void,
    OrganizationLicensesResponse
>({
    path: "admin/organizations/:organizationId/licenses",
    method: "GET",
    type: ADMIN_GET_ORGANIZATION_LICENSES,
});

export const saveOrganizationLicense = createRsaaAction<
    UpdateOrganizationLicenseRequest,
    OrganizationLicenseResponse
>({
    path: "admin/organizations/:organizationId/licenses/:organizationLicenseId",
    method: "PATCH",
    type: ADMIN_SAVE_ORGANIZATION_LICENSE,
});

export const getOrganizationUsers = createRsaaAction<
    void,
    OrganizationUsersResponse
>({
    path: "admin/organizations/:organizationId/users",
    method: "GET",
    type: ADMIN_GET_ORGANIZATION_USERS,
});

export const setOrganizationUserPassword = createRsaaAction<
    SetUserPasswordRequest,
    string
>({
    path: "admin/users/:userId/password",
    method: "PUT",
    type: ADMIN_SET_ORGANIZATION_USER_PASSWORD,
});

export const updateOrganizationFeatures = createRsaaAction<
    UpdateOrganizationFeaturesRequest,
    OrganizationsFeaturesResponse
>({
    path: "admin/organizations/:organizationId/features",
    method: "PUT",
    type: ADMIN_UPDATE_ORGANIZATION_FEATURES,
});

export const getOrganizationFeatures = createRsaaAction<
    void,
    OrganizationsFeaturesResponse
>({
    path: "admin/features/:organizationId",
    method: "GET",
    type: ADMIN_GET_ORGANIZATION_FEATURES,
});

export type IOrganizationsBillingCustomersResponse =
    OrganizationsBillingCustomersResponse;

export const getOrganizationBillingCustomers = createRsaaAction<
    void,
    IOrganizationsBillingCustomersResponse
>({
    path: "admin/billing/customers/:organizationId",
    method: "GET",
    type: ADMIN_GET_ORGANIZATION_BILLING_CUSTOMERS,
});

export const createAccount = createRsaaAction<
    CreateAccountRequest,
    CreateAccountResponse
>({
    path: "admin/createAccount",
    method: "POST",
    type: ADMIN_CREATE_ACCOUNT,
});

export const closeCreateAccountResult = createAction(
    ADMIN_CLOSE_CREATE_ACCOUNT_RESULT
);
